module.exports = __webpack_public_path__ + "img/ИФ-1(А)-028-m.a05ee912.png";